<template>
  <v-card
    max-width="1024"
  >

    <v-card-text>
      <p class="display-1 mt-4 text--primary">
        Expiring soon
      </p>
    </v-card-text>
    <table class="final-table lines-b pointer hover full-width">
      <colgroup ref="colgroup1">
        <col width="60px">
        <col width="15px">
        <col width="15px">
      </colgroup>

      <row
      v-for="item in items" 
      :key="item.id"
      :item="item"
      :searchFilters="filters.search"
      @click.native="clickRow(item)"
      ></row>

    </table>

    <!-- PAGINATION -->
    <c-pagination
    :page="page"
    :pagination="pagination"
    :filters="filters"
    @updatePageNumber="updatePageNumber"
    @goToFirstPage="goToFirstPage"
    @goToPreviousPage="goToPreviousPage"
    @goToNextPage="goToNextPage"
    @goToLastPage="goToLastPage"
    ></c-pagination>
    <!-- PAGINATION -->

  </v-card>
</template>

<script>
import ServerListController from '@/mixins/ServerListController'
import ServerListBindings from '@/mixins/ServerListBindings'
import Row from './row'

export default {
  mixins: [ServerListController, ServerListBindings],
  components: {
    Row
  },
  data () {
    return {
      filters: {
        rowsPerPage: 10,
        sortCol: 'name_inventory_item',
        sortAscending: true,
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          id: '',
          name_inventory_item: '',
          name_build: '',
        },
        active: {
          customer: false,
          date: false
        },
        categories: []
      },
      page: 0
    }
  },
  methods: {
    clickRow (item) {
      this.$router.push('/inventory/inventory-definition/view/' + item.inventory_item_id)
    },
    loadAPI: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        const encodedFilters = btoa(JSON.stringify(this.filters))
        this.$axios.get(`/inventory/expiring-soon?filters=${encodedFilters}&page=${this.page}`)
          .then(response => {
            var rows = response.data.rows
            this.pagination.rowCount = response.data.count
            this.pagination.pages = Math.ceil(this.pagination.rowCount / this.filters.rowsPerPage)
            this.items = rows
            resolve(response.data)
          })
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
      })
    }, 150, {leading: true}),
  },
  created () {
    this.loadAPI()
  }
}
</script>